import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class F1TelemetryStore extends LocalModel {
    constructor() {
        super('f1Telemetry', {
            namePlural: 'f1Telemetries',
            namePluralReal: 'f1telemetry',
            sort: 'driverNumber',
            limit: 100,
            api: {
                search: {
                    url: '/api/f1telemetry/',
                    params: {
                        limit: 100,
                        sort: 'driverNumber',
                    },
                },
                load: {
                    url: '/api/f1telemetry/',
                    params: {},
                },
                save: {
                    url: '/api/f1telemetry/',
                    params: {},
                },
                delete: {
                    url: '/api/f1telemetry/',
                    params: {},
                },
            },
        });
    }

    @observable f1Telemetries = [];

    @observable f1Telemetry = {};

    @observable newF1Telemetry = {};

    @action
    async loadDriverTelemetry(sessionKey, driverNumber) {
        const response = await util.fetchApi('/api/f1telemetry/', { method: 'GET' }, {
            sessionKey,
            driverNumber,
            includeLaps: '1',
        });
        if (response && response.data && response.data.length > 0) {
            this.updateKeyValue('f1Telemetry', response.data[0]);
        }
        return response;
    }
}

const store = new F1TelemetryStore();
export default store;
